import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import AdminLogin from "./pages/AdminLogin";
import WorkerLogin from "./pages/WorkerLogin";
import AdminLayout from "./pages/AdminLayout";
import Overview from "./pages/admin/Overview";
import Clients from "./pages/admin/Clients";
import Projects from "./pages/admin/Projects";
import Workers from "./pages/admin/Workers";
import Attendance from "./pages/admin/Attendance";
import Photos from "./pages/admin/Photos";
import LatePunch from "./pages/admin/LatePunch";
import Hours from "./pages/admin/Hours";
import Settings from "./pages/admin/Settings";
import WorkerDashboard from "./pages/WorkerDashboard";

function RequireAuth({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#475569]">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/employee/login" element={<WorkerLogin />} />

          <Route
            path="/admin"
            element={
              <RequireAuth role="admin">
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Overview />} />
            <Route path="clients" element={<Clients />} />
            <Route path="projects" element={<Projects />} />
            <Route path="employees" element={<Workers />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="photos" element={<Photos />} />
            <Route path="late" element={<LatePunch />} />
            <Route path="hours" element={<Hours />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          <Route
            path="/employee"
            element={
              <RequireAuth role="worker">
                <WorkerDashboard />
              </RequireAuth>
            }
          />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
